import styled from '@emotion/styled'
import {Spacing} from 'types/Theme'

import {cssTheme} from '@vio/atlas/themes'

export const WrapperWithPadding = styled('section')<{
  paddingTop?: Spacing
  paddingBottom?: Spacing
}>`
  padding-left: ${cssTheme.layout.spacing.s500};
  padding-right: ${cssTheme.layout.spacing.s500};
  padding-top: ${({paddingTop = 's700'}) =>
    cssTheme.layout.spacing[paddingTop]};
  padding-bottom: ${({paddingBottom = 's700'}) =>
    cssTheme.layout.spacing[paddingBottom]};
`
